import React from "react";
const BlocksContext = React.createContext({});
export {
  BlocksContext as default
};
